import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ActividadGrupoEspecie, Error } from '@rpe/registro-personas-empresas-lib';

// LOAD
export const entityActividadesGrupoEspecieLoadRequest = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Load Request'
);

export const entityActividadesGrupoEspecieLoadFailure = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Load Failure',
  props<{ error: Error }>()
);

export const entityActividadesGrupoEspecieLoadSuccess = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Load Success',
  props<{ items: ActividadGrupoEspecie[] }>()
);

// ADD
export const entityActividadesGrupoEspecieAddRequest = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Add Request',
  props<{ item: ActividadGrupoEspecie[] }>()
);

export const entityActividadesGrupoEspecieAddFailure = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Add Failure',
  props<{ error: Error }>()
);

export const entityActividadesGrupoEspecieAddSuccess = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Add Success',
  props<{ item: ActividadGrupoEspecie[] }>()
);


// CHANGE
export const entityActividadesGrupoEspecieChangeRequest = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Change Request',
  props<{ item: ActividadGrupoEspecie }>()
);

export const entityActividadesGrupoEspecieChangeFailure = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Change Failure',
  props<{ error: Error }>()
);

export const entityActividadesGrupoEspecieChangeSuccess = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Change Success',
  props<{ item: Update<ActividadGrupoEspecie> }>()
);

// DELETE
export const entityActividadesGrupoEspecieDeleteRequest = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Delete Request',
  props<{ item: ActividadGrupoEspecie }>()
);

export const entityActividadesGrupoEspecieDeleteFailure = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Delete Failure',
  props<{ error: Error }>()
);

export const entityActividadesGrupoEspecieDeleteSuccess = createAction(
  '[ENTITYACTIVIDADESGRUPOESPECIE] Delete Success',
  props<{ item: ActividadGrupoEspecie }>()
);
